/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ResetPasswordInput = {|
  clientMutationId?: ?string,
  email: string,
  resetToken: string,
  password: string,
|};
export type Login_resetPassword_MutationVariables = {|
  input: ResetPasswordInput
|};
export type Login_resetPassword_MutationResponse = {|
  +resetPassword: ?{|
    +jwt: ?string
  |}
|};
export type Login_resetPassword_Mutation = {|
  variables: Login_resetPassword_MutationVariables,
  response: Login_resetPassword_MutationResponse,
|};
*/


/*
mutation Login_resetPassword_Mutation(
  $input: ResetPasswordInput!
) {
  resetPassword(input: $input) {
    jwt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetPasswordPayload",
    "kind": "LinkedField",
    "name": "resetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jwt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Login_resetPassword_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Login_resetPassword_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b291bd7a52ed9af9f3d41712d2b1469",
    "id": null,
    "metadata": {},
    "name": "Login_resetPassword_Mutation",
    "operationKind": "mutation",
    "text": "mutation Login_resetPassword_Mutation(\n  $input: ResetPasswordInput!\n) {\n  resetPassword(input: $input) {\n    jwt\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a712f0d2dfe617756ed7adb30ce9b806';

module.exports = node;
